import React from 'react';
import styles from './LoadingPage.module.scss'
import scLogo from '../../../assets/logo-purple.png';

const PageNotFound = () => {

        return (
            <div className={styles.pageContainer}>
                <div className={styles.container}>
                    <div className={styles.loader} />
                    <img src={scLogo} alt={''} className={styles.logo}/>
                    {/*<div className={styles.subtitle}>*/}

                    {/*    Page not found*/}
                    {/*</div>*/}
                    {/*<div className={styles.explain}>*/}
                    {/*    We're sorry, the page you requested could not be found. please go back to safety or contact us.*/}
                    {/*</div>*/}
                    {/*<BiBug className={styles.bug}/>*/}
                </div>
            </div>
        )

}

export default PageNotFound;
